module.exports = __webpack_public_path__ + "img/kiosk-mach-map.3ee880e4.jpg";